import { FilterState,ValueLabel } from '../interface/MyInterfaces'
//import fetch from 'isomorphic-fetch';


export default function (state: FilterState = {} , action) {
    let propertyName: string;
    switch (action.type) {
        case "FILTER_ITEMS_LOADING":
            return action.payload;
        case "BAD_LINK":
            return action.payload;
        case "LOAD_LINK":
            var linkStuff = action.payload;

            var newState = Object.assign({}, state);
            newState["start_year"] = linkStuff["start_year"];
            newState["end_year"] = linkStuff["end_year"];
            newState["work_study"] = linkStuff["work_study"];
            newState["report_type"] = linkStuff["spending_type"];
            newState["aggregate"] = linkStuff["agg"];
            newState["negative"] = linkStuff["negative_payment"];
            newState["bench_year"] = linkStuff["bench_year"];
            newState["bench_schools"] = linkStuff["bench_school_names"]; 
            newState["showModal"] = false;

            newState["Initial_the_university"] = linkStuff["university"];

            return newState;
        case "OPEN_FILTER":
            propertyName = "showModal";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "START_YEAR_CHANGE":
            propertyName = "start_year";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            if (newState["end_year"] !== undefined) {
                var end_year = newState["end_year"];
                if (end_year !== undefined)
                    newState["hide_error"] = action.payload <= end_year;  
            }
            return newState;
        case "END_YEAR_CHANGE":
            propertyName = "end_year";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            if (newState["start_year"] !== undefined) {
                var start_year = newState["start_year"];
                if (start_year !== undefined)
                    newState["hide_error"] = action.payload >= start_year;
            }
            return newState;
        case "HANDLE_INPUT_CHANGE":
            propertyName = action.payload.name;
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload.value;
            return newState;
        case "WORK_STUDY_CHANGE":
            propertyName = "work_study";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "AGGREGATE_CHANGE":
            propertyName = "aggregate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "NEGATIVE_CHANGE":
            propertyName = "negative";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "BENCH_YEAR_CHANGE":
            propertyName = "bench_year";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;

            // when bench year changes - load appropriate bench schools
            var all_years_schools = newState["Initial_bench_years"];
            if (all_years_schools !== undefined) {

                for (var i in all_years_schools) {
                    if (all_years_schools[i].year == action.payload) {

                        var bs: ValueLabel[] = [];
                        for (var j in all_years_schools[i].schools) {
                            bs.push(all_years_schools[i].schools[j]);
                        }
                        
                        newState["bench_schools"] = bs;
                    }
                }
                
            }
            return newState;
        case "BENCH_SCHOOLS_CHANGE":
            propertyName = "bench_schools";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "GET_AGG_SCHOOLS":
            propertyName = "agg_schools";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CLOSE_FILTER":
            propertyName = "showModal";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        default:
            return state;
    }
}